/**
 * Browse mode lists only the bookmarks that run a search or open a folder.
 */
export function isBrowsableBookmark(bookmark: { path: string }): boolean {
  return bookmark.path.startsWith('/?searchString') || bookmark.path.includes('/folders') || bookmark.path.includes('/search-item');
}

export function isBookmarkVisibleToGroups(visibleToGroups: readonly string[] | null | undefined, groups: readonly string[]): boolean {
  if (visibleToGroups === null || visibleToGroups === undefined || visibleToGroups.length === 0) {
    return true;
  }
  return groups.some(group => visibleToGroups.includes(group));
}

export function getSanitizedFolderPath(path: string) {
  const pathSegments = path.split('/').filter(s => s.length > 0);
  return { sanitizedPath: `/${pathSegments.join('/')}`, pathSegments };
}
